import { canEditModule, canReadModule } from './accessRightsHelpers';

export { canEditModule, canReadModule };
